export default __webpack_public_path__ + "static/media/Teacher1.572bb2db.jpg";